const Roadmap = () => {
    return(
        <section id="roadmap-background">
            <div className="OUR-TEAM">
                <h3>ROADMAP</h3> </div>
            <div className="background-zig-zag">
                <div className="main-content">
                    <div className="title">
                        <h3>0% Stage 1</h3> </div>
                    <div className="content-text">
                        <h3>The Council of Gyld</h3>
                        <p>Cryptids reveal themselves to the world and form the Council of Gyld.</p>
                    </div>
                </div>
                <div className="main-content-two">
                    <div className="title-two">
                        <h3> 20% Stage 2</h3> </div>
                    <div className="content-text-two">
                        <h3>Whitelist</h3>
                        <p>Legendao opens whitelist spots for the Council of Gyld NFT collection, which will entitle each</p>
                        <p>Cryptid avatar for use on the Legendao platform with eventual evolution to a</p>
                        <p>3D Cryptid avatar.</p>
                    </div>
                </div>
                <div className="main-content-three">
                    <div className="title-three">
                        <h3>40% Stage 3</h3> </div>
                    <div className="content-text-three">
                        <h3>Staking Bonus</h3>
                        <p>Council of Gyld NFT holders will always receive an APR bonus for their $LGND regardless of rank.</p>
                        <p> If you hold a Council of Gyld NFT, you enjoy enhanced staking, collecting and earning benefits</p>
                        <p>It's as simple as that.</p>
                    </div>
                </div>
                <div className="main-content-four">
                    <div className="title-four">
                        <h3>60% Stage 4</h3> </div>
                    <div className="content-text-four">
                        <h3>Meet Your 3D Avatar</h3>
                        <p>Your 3D Cryptid avatar is free when you hold a Council of Gyld NFT!</p>
                        <p>Use your avatar to gain experience and level up to access more and more collecting and staking benefits.</p>
                    </div>
                </div>
                <div className="main-content-five">
                    <div className="title-five">
                        <h3>80% Stage 5</h3> </div>
                    <div className="content-text-five">
                        <h3>Gain a Free Lootbox</h3>
                        <p>Your Cryptid just keeps on giving. Each Cryptid holder will receive a free Lootbox.</p>
                    </div>
                </div>
                <div className="main-content-six">
                    <div className="title-six">
                        <h3>100% Stage 6</h3> </div>
                    <div className="content-text-six">
                        <h3>Level Achieved: Legendao OG Status</h3>
                        <p>Anyone who collected a Council of Gyld NFT will be granted OG status.</p>
                        <p> OG status will be displayed on your avatar as a non-transferable, exclusive pair of wings marking you forever as a Legendao OG.</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Roadmap;